const data = [
    {
        name : 'Kisaan Beej Kirana',
        image : require('./assets/3.png'),
        place : 'Delhi NCR',
        lead : 775,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 1,
    },
    {
        name : 'Shubham Agri Store',
        image : require('./assets/4.png'),
        place : 'Kanpur, Uttar Pradesh',
        lead : 226,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 1,
    },
    {
        name : 'Delhi Agro Co.',
        image : require('./assets/5.png'),
        place : 'Gurgaon, Haryana',
        lead : 775,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 0,
    },
    {
        name : 'Kisaan Beej Kirana',
        image : require('./assets/3.png'),
        place : 'Delhi NCR',
        lead : 775,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 0,
    },
    {
        name : 'Shubham Agri Store',
        image : require('./assets/4.png'),
        place : 'Kanpur, Uttar Pradesh',
        lead : 226,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 1,
    },
    {
        name : 'Delhi Agro Co.',
        image : require('./assets/5.png'),
        place : 'Gurgaon, Haryana',
        lead : 775,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 0,
    },
    {
        name : 'Kisaan Beej Kirana',
        image : require('./assets/3.png'),
        place : 'Delhi NCR',
        lead : 775,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 1,
    },
    {
        name : 'Shubham Agri Store',
        image : require('./assets/4.png'),
        place : 'Kanpur, Uttar Pradesh',
        lead : 226,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 0,
    },
    {
        name : 'Delhi Agro Co.',
        image : require('./assets/5.png'),
        place : 'Gurgaon, Haryana',
        lead : 775,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 1,
    },
    {
        name : 'Kisaan Beej Kirana',
        image : require('./assets/3.png'),
        place : 'Delhi NCR',
        lead : 775,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 1,
    },
    {
        name : 'Shubham Agri Store',
        image : require('./assets/4.png'),
        place : 'Kanpur, Uttar Pradesh',
        lead : 226,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 0,
    },
    {
        name : 'Delhi Agro Co.',
        image : require('./assets/5.png'),
        place : 'Gurgaon, Haryana',
        lead : 775,
        customer : 568,
        conversion : 87,
        sell : 'Rs. 2,25,253',
        isFavorite : 1,
    },
   
]


export default data;